import { useDraggable } from "@dnd-kit/core";
import {
  FunctionComponent,
  KeyboardEvent,
  ReactElement,
  SVGProps,
  useCallback,
} from "react";

import { Entity } from "../api";
import IconGrip from "../assets/icons/grip.svg";
import { SidebarItem } from "./catalyst/SidebarItem";
import { SidebarLabel } from "./catalyst/SidebarLabel";

interface DraggableMenuItemProps {
  backgroundColor?: string;
  entity: Entity;
  icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  iconColor: string;
  onEnterPress?: (entity: Entity) => void;
  text: string;
}

export const DraggableMenuItem = ({
  backgroundColor,
  entity,
  icon: IconComponent,
  iconColor,
  onEnterPress,
  text,
}: DraggableMenuItemProps): ReactElement => {
  const { attributes, listeners, setNodeRef } = useDraggable({
    data: {
      entity,
      text,
    },
    id: `menu-item-${entity.id}`,
  });

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        onEnterPress?.(entity);
      }
    },
    [entity, onEnterPress],
  );

  return (
    <SidebarItem
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      contentClassName="cursor-grab flex min-w-0"
      onKeyDown={handleKeyDown}
      role="button"
      style={backgroundColor ? { backgroundColor } : undefined}
      tabIndex={0}
    >
      <IconComponent
        className="flex-shrink-0"
        style={{
          color: iconColor,
        }}
      />

      <SidebarLabel className="min-w-0 flex-1">{text}</SidebarLabel>

      <IconGrip className="ml-auto h-4 w-4 flex-shrink-0 text-zinc-500" />
    </SidebarItem>
  );
};
